import request from '@/fetch/index'

// 获取产品列表
export function getProductPagingList (params) {
  return request({
    url: '/api/loan/product/h5/product-paging',
    methods: 'GET',
    params
  })
}

// 根据 部分字段ids 获取返回值中对应的数据
export function getProductCondition () {
  return request({
    url: '/api/loan/product/app/condition',
    methods: 'GET'
  })
}

// GET 产品详情
export function getProductDetail (id) {
  return request({
    url: `/api/loan/product/app/${id}/product-detail`,
    methods: 'GET'
  })
}

// 获取查询条件
export function getProductListCondition (params) {
  return request({
    url: `/api/loan/product/app/list-condition`,
    methods: 'GET',
    params
  })
}

// 获取标签列表
export function getProductLabelList (districtId) {
  return request({
    url: '/api/loan/label/list',
    methods: 'GET',
    params: {
      districtId
    }
  })
}
